/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownRightIcon16Regular = forwardRef('ArrowDRadiusDownRightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.75 3C2.75 5.9 5.1 8.25 8 8.25h4.94L9.72 5.03a.75.75 0 0 1 1.06-1.06l3.652 3.651a1.95 1.95 0 0 1 0 2.758L10.78 14.03a.75.75 0 1 1-1.06-1.06l3.22-3.22H8A6.75 6.75 0 0 1 1.25 3v-.25a.75.75 0 0 1 1.5 0V3Z" })));
});
